import { render, staticRenderFns } from "./CoinSelectBox.vue?vue&type=template&id=654001a6&scoped=true"
import script from "./CoinSelectBox.vue?vue&type=script&lang=js"
export * from "./CoinSelectBox.vue?vue&type=script&lang=js"
import style0 from "./CoinSelectBox.vue?vue&type=style&index=0&id=654001a6&prod&lang=scss&scoped=true"
import style1 from "./CoinSelectBox.vue?vue&type=style&index=1&id=654001a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654001a6",
  null
  
)

export default component.exports